import {reactive} from 'vue'
import axios from "axios";
import VueJwtDecode from 'vue-jwt-decode';
import {ID_API_URL} from "@/api/base";
import router from "@/router";
import {user} from "@/data/user";

let refreshPromise = null

export const auth = reactive({
    access_token: '',
    refresh_token: '',
    user_id: '',

    setToken(access_token, refresh_token) {
        this.access_token = access_token
        this.refresh_token = refresh_token
        this.user_id = VueJwtDecode.decode(this.access_token)['sub']

        localStorage.setItem('access_token', this.access_token)
        localStorage.setItem('refresh_token', this.refresh_token)
        localStorage.setItem('user_id', this.user_id)
    },

    async getAccessToken() {
        if (!this.access_token && localStorage.getItem('access_token')) {
            this.access_token = localStorage.getItem('access_token')
        }
        if(!this.access_token){
            await this.logout()
            return ''
        }
        if (isTokenExpired(this.access_token)) {
            try {
                await this.refresh()
            } catch (error) {
                return this.access_token
            }
        }
        return this.access_token
    },

    getRefreshToken() {
        if (!this.refresh_token && localStorage.getItem('refresh_token')) {
            this.refresh_token = localStorage.getItem('refresh_token')
        }
        return this.refresh_token
    },

    /**
     * Обновляет пару токенов через ID. Параллельные вызовы получают один и тот же промис.
     * @returns {Promise<string>} новый access_token или пустая строка, если пользователь разлогинен
     */
    refresh() {
        if (!refreshPromise) {
            refreshPromise = this.requestRefresh().finally(() => {
                refreshPromise = null
            })
        }
        return refreshPromise
    },

    async requestRefresh() {
        const refresh_token = this.getRefreshToken()
        if (!refresh_token) {
            await this.logout()
            return ''
        }
        try {
            const result = await axios.post(
                `${ID_API_URL}/v1/auth/refresh`,
                {},
                {headers: {'Authorization': `Bearer ${refresh_token}`}}
            )
            this.setToken(result.data.access_token, result.data.refresh_token || refresh_token)
            return this.access_token
        } catch (error) {
            const status = error.response?.status
            if (status === 401 || status === 403) {
                await this.logout()
                return ''
            }
            throw error
        }
    },

    async logout() {
        this.access_token = ''
        this.refresh_token = ''
        this.user_id = ''

        await user.afterLogout()

        localStorage.setItem('access_token', '')
        localStorage.setItem('refresh_token', '')
        localStorage.setItem('user_id', '')

        if (router.currentRoute.value.name !== 'login') {
            await router.push({name: 'login'})
        }
    },

    checkAuth() {
        return !!this.getAccessToken();
    }
})

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function isTokenExpired(token) {
    const decoded = parseJwt(token);
    const exp = decoded.exp;
    const currentTime = Math.floor(Date.now() / 1000);
    return exp < currentTime; // Return true if token is expired
}
